import { StyleSheet, Dimensions } from 'react-native';

const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = Dimensions.get('window');

export const createStyles = (theme: 'light' | 'dark' = 'light') => {
  const colors = {
    light: {
      background: '#000000',
      text: '#FFFFFF',
      subText: '#CCCCCC',
      button: 'rgba(255,255,255,0.9)',
      buttonText: '#333333',
      indicator: '#FFFFFF',
      indicatorInactive: 'rgba(255,255,255,0.4)',
      closeButton: 'rgba(255,255,255,0.3)',
    },
    dark: {
      background: '#000000',
      text: '#FFFFFF',
      subText: '#CCCCCC',
      button: 'rgba(255,255,255,0.9)',
      buttonText: '#333333',
      indicator: '#FFFFFF',
      indicatorInactive: 'rgba(255,255,255,0.4)',
      closeButton: 'rgba(255,255,255,0.3)',
    },
  };

  const c = colors[theme];

  return StyleSheet.create({
    // Modal容器
    container: {
      flex: 1,
      backgroundColor: c.background,
    },
    overlay: {
      ...StyleSheet.absoluteFillObject,
      backgroundColor: c.background,
    },
    // Header
    header: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 10,
      paddingTop: 50,
      paddingHorizontal: 16,
      paddingBottom: 16,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    headerGradient: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: 100,
      backgroundColor: 'transparent',
    },
    closeButton: {
      width: 36,
      height: 36,
      borderRadius: 18,
      backgroundColor: c.closeButton,
      alignItems: 'center',
      justifyContent: 'center',
    },
    closeIcon: {
      fontSize: 24,
      color: c.text,
      fontWeight: '300',
    },
    headerRight: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 12,
    },
    actionButton: {
      width: 36,
      height: 36,
      borderRadius: 18,
      backgroundColor: c.closeButton,
      alignItems: 'center',
      justifyContent: 'center',
    },
    actionIcon: {
      fontSize: 18,
      color: c.text,
    },
    // Content
    contentContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    scrollView: {
      flex: 1,
    },
    imageContainer: {
      width: SCREEN_WIDTH,
      height: SCREEN_HEIGHT,
      justifyContent: 'center',
      alignItems: 'center',
    },
    image: {
      width: SCREEN_WIDTH,
      height: SCREEN_HEIGHT * 0.7,
      resizeMode: 'contain',
    },
    // Loading
    loadingContainer: {
      ...StyleSheet.absoluteFillObject,
      justifyContent: 'center',
      alignItems: 'center',
    },
    loadingText: {
      marginTop: 8,
      fontSize: 12,
      color: c.subText,
    },
    // Error
    errorContainer: {
      ...StyleSheet.absoluteFillObject,
      justifyContent: 'center',
      alignItems: 'center',
    },
    errorIcon: {
      fontSize: 40,
      color: c.subText,
    },
    errorText: {
      marginTop: 8,
      fontSize: 12,
      color: c.subText,
    },
    // Footer
    footer: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 10,
      paddingBottom: 40,
      paddingHorizontal: 16,
      paddingTop: 16,
    },
    footerGradient: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: 100,
      backgroundColor: 'transparent',
    },
    description: {
      fontSize: 14,
      color: c.text,
      lineHeight: 20,
      textAlign: 'center',
    },
    // Indicator - Dots
    indicatorContainer: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      paddingVertical: 16,
    },
    indicatorDot: {
      width: 6,
      height: 6,
      borderRadius: 3,
      backgroundColor: c.indicatorInactive,
      marginHorizontal: 4,
    },
    indicatorDotActive: {
      backgroundColor: c.indicator,
      width: 8,
      height: 8,
      borderRadius: 4,
    },
    // Indicator - Number
    indicatorNumber: {
      paddingHorizontal: 12,
      paddingVertical: 6,
      backgroundColor: 'rgba(0,0,0,0.5)',
      borderRadius: 12,
    },
    indicatorNumberText: {
      fontSize: 13,
      color: c.text,
    },
    // Gallery
    galleryContainer: {
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    galleryImage: {
      resizeMode: 'cover',
    },
    galleryOverflow: {
      ...StyleSheet.absoluteFillObject,
      backgroundColor: 'rgba(0,0,0,0.5)',
      justifyContent: 'center',
      alignItems: 'center',
    },
    galleryOverflowText: {
      fontSize: 18,
      fontWeight: '600',
      color: '#FFFFFF',
    },
  });
};

export const SCREEN_DIMENSIONS = {
  width: SCREEN_WIDTH,
  height: SCREEN_HEIGHT,
};

export default createStyles;
